const Header = ({ connectWalletPressed, walletAddress, enabled }) => (
  <header id="navbar">
    <div className="logo">decentratlot</div>
      {enabled
      ? walletAddress.length > 0 
        ? <div className="connected">
            <div className="wrap"><div className="blur"></div><div className="green_light"></div></div>
            <div className="address">&nbsp;{walletAddress}</div>
          </div>
        : <div><button id="walletButton" onClick={connectWalletPressed}>Connect<span> Wallet</span></button></div>
      : <div><button id="walletButon" className="deactivated">Connect<span> Wallet</span></button></div>
      }
  </header>
);

export default Header
